import { track } from '@eventbrite/datalayer-library';
import { Button } from '@eventbrite/eds-button';
import { LogoEBrand, VerifiedIcon } from '@eventbrite/eds-iconography';
import { HAS_DOCUMENT } from '@eventbrite/eds-utils';
import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { gettext } from '@eventbrite/i18n';
import React, { useEffect, useState } from 'react';
import { ScrollableDrawer } from '../../../ScrollableDrawer/ScrollableDrawer';
import './CreatorBadge.scss';

interface CreatorBadgeProps {
    variantSource?: string;
}

export const CreatorBadge: React.FunctionComponent<CreatorBadgeProps> = ({
    variantSource,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const onClickOutside = () => {
        setIsModalOpen(false);
    };
    useEffect(() => {
        track({
            eventName: 'ViewVerificationBadge',
            eventData: {
                badgeType: variantSource,
            },
        });
    }, [variantSource]);

    const trackBadgeClick = () => {
        track({
            eventName: 'ClickVerificationBadge',
            eventData: {
                badgeType: variantSource,
            },
        });
    };
    return (
        <>
            {variantSource === 'verification-badge' ? (
                <section
                    className="creator_badge_section_variant_a"
                    onClick={() => {
                        setIsModalOpen(true);
                        trackBadgeClick();
                    }}
                >
                    <div
                        className="creator_badge"
                        data-testid="creator-badge-test-id"
                    >
                        <LogoEBrand fill="white" />
                    </div>
                    <div className="creator_text">{gettext('Verified')}</div>

                    {isModalOpen && (
                        <ScrollableDrawer
                            onClickOutside={onClickOutside}
                            heightFixed={'236px'}
                            isScrollUpAllowed={false}
                        >
                            <BadgeScrollableDrawerContent
                                onClickOutside={onClickOutside}
                                heading="What does “verified” mean?"
                                content="We’ve met these event organizers and confirmed their identity. We work with them to bring you unique things to do."
                            />
                        </ScrollableDrawer>
                    )}
                </section>
            ) : (
                <section
                    className="creator_tick_variant_b"
                    onClick={() => {
                        setIsModalOpen(true);
                        trackBadgeClick();
                    }}
                >
                    <div data-testid="creator-badge-test-id">
                        <VerifiedIcon />
                    </div>
                    {isModalOpen && (
                        <ScrollableDrawer
                            onClickOutside={onClickOutside}
                            heightFixed={'260px'}
                            isScrollUpAllowed={false}
                        >
                            <BadgeScrollableDrawerContent
                                onClickOutside={onClickOutside}
                                heading="Verified events"
                                content="We have worked closely with few creators who are Eventbrite Partners to verify their identity. Thus have the confidence that these are verified events."
                            />
                        </ScrollableDrawer>
                    )}
                </section>
            )}
        </>
    );
};

interface BadgeScrollableDrawerContentProps {
    onClickOutside: () => void;
    heading: string;
    content: string;
}

export const BadgeScrollableDrawerContent: React.FC<
    BadgeScrollableDrawerContentProps
> = ({ onClickOutside, heading, content }) => {
    if (!HAS_WINDOW || !HAS_DOCUMENT) {
        return null;
    }

    return (
        <div className="scrollable-drawer" data-testid="scrollable-drawer">
            <div className="creator_badge_content">
                <div className="creator_badge_scroll_heading">{heading}</div>
                <div className="creator_badge_scroll_content">{content}</div>
                <Button onClick={onClickOutside}>Got it</Button>
            </div>
        </div>
    );
};
